const unemployedStatuses = ['student', 'intern', 'civic_service', 'unemployed', 'other'];
const studentStatuses = ['student', 'intern', 'apprenticeship_contract', 'professional_contract', 'employed_student'];
const guarantorTypes = ['visale', 'association', 'employer', 'institutional', 'other', 'none_unknown'];
if (document.getElementById('vue-form')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin, MobileValidate],
		el: '#vue-form',
		computed: {
			furthestStep() {
				return this.steps.findIndex((el) =>
					el.sections.hasOwnProperty(this.record['application_form_furthest_step'])
				);
			},
			// activeSteps: function () {
			//   return this.steps.filter(step => step.isActive).length
			// }
		},
		data: {
			scepiaCandidateId: '',
			user: {},
			record: {},
			isShortLived: false,
			residentId: null,
			recordResidences: {},
			documents: [],
			dropdowns: {},
			currentStep: 0,
			isComplete: false,
			isLoading: false,
			dataFeedback: {},
			steps: [],
			showField: false,
			feedbackSent: false,
			section: {
				labelSubmit: '',
				title: gettext('Vos retours'),
				fields: {
					note: {
						label: gettext('Vous venez de faire une demande de logement, comment évaluez-vous le formulaire de candidature ? (1 étant la note la plus faible et 4, la plus haute)'),
						component: 'radio',
						options: [
							{
								label: '1',
								value: 1
							},
							{
								label: '2',
								value: 2
							},
							{
								label: '3',
								value: 3
							},
							{
								label: '4',
								value: 4
							}
						],
						model: {}
					},
					difficulties_encounter: {
						label: gettext('Avez-vous rencontré des difficultés pendant la saisie de la candidature ?'),
						component: 'radio',
						name: 'difficulties_encounter',
						options: [
							{
								label: gettext('oui'),
								value: true
							},
							{
								label: gettext('non'),
								value: false
							}
						],
						model: {}
					},
					difficulties_detail: {
						label: '',
						component: 'textarea',
						can_be_hidden: true,
						model: {},
					},
					improvements: {
						label: gettext('Avez-vous des améliorations ou suggestions à faire quant à la demande de logement ?'),
						component: 'textarea',
						model: {},
						optional: true
					},
					email: {
						label: gettext('Dans le cadre de notre démarche qualité, acceptez-vous d\'être recontacté dans un mois par mail par nos équipes pour répondre à davantage de questions sur votre candidature chez Résidétape ? Si oui, merci de renseigner votre adresse mail'),
						component: 'input',
						type: 'email',
						model: {},
						validate: 'email',
						optional: true
					}
				},
				config: {
					rows: [
						{
							title: gettext('Afin de nous aider à améliorer notre formulaire de demande de logement, votre avis nous intéresse !'),
							titleClasses: 'title is-xlarge is-primary text-center mb-20',
							classes: 'pb-20 justify-center',
							cols: [
								{
									classes: 'col-md-12',
									labelClasses: 'col-12 text-left mb-20',
									fieldClasses: 'col-12 text-left',
									fields: [
										'note'
									]
								},
								{
									classes: 'col-md-12 mt-40',
									labelClasses: 'col-12 text-left mb-20',
									fieldClasses: 'col-12 text-left',
									fields: [
										'difficulties_encounter',
										'difficulties_detail',
										'improvements',
										'email'
									]
								},
								// 	{
								// 		classes: 'col-md-12 mt-40',
								// 		labelClasses: 'col-12 text-left mb-20',
								// 		fieldClasses: 'col-12 text-left',
								// 		fields: [
								// 			'improvements',
								// 			'email'
								// 		]
								// },
							],
						},
					]
				}
			},
			feedbackErrors: {}
		},
		created() {
			this.$validator.localize(gettext('fr'), dict);
			this.$validator.extend('phone', MobileValidate);
		},
		mounted() {
			this.user = JSON.parse(localStorage.getItem('user'));
			this.residentId = Number.isInteger(parseInt(getLastUrlSegment()))
				? parseInt(getLastUrlSegment())
				: this.user.id;
			axios.all([this.getRecord()]).then(() => {
				//this.setFurthestSection();
			});
			this.getDocs();
			// this.getDropdowns();
			// this.getRecord();
		},
		methods: {
			setData() {
				this.steps = [{
					name: gettext('dossier'),
					description: '',
					activeSection: 'appartment_characteristics',
					sections: {
						appartment_characteristics: {
							endpoint: 'residence-requests/appartment-characteristics',
							labelSubmit: gettext('Enregistrer'),
							// title: 'caractéristiques du logement souhaité',
							fields: {
								residence: {
									label: gettext('Résidence'),
									labelTop: true,
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {},
									readOnly:
										JSON.parse(localStorage.getItem('user')).created_by_partner &&
											JSON.parse(localStorage.getItem('user')).role !== 'collaborator'
											? true
											: false
								},
								residences: {
									label: gettext('Choix'),
									component: 'repeater',
									repeat: 3,
									startIndex: 0,
									nextFieldsOptionals: true,
									repeaterFields: ['residence'],
									model: []
								},
								starting_date_wish: {
									label: gettext("Date d'entrée souhaitée"),
									component: 'datepicker',
									model: {}
								},
								nb_adults_wish: {
									label: gettext('Adultes'),
									description: gettext("Nombre d'occupants"),
									component: 'radio',
									options: [
										{
											label: '1',
											value: 1
										},
										{
											label: '2',
											value: 2
										}
									],
									model: {}
								},
								nb_children_wish: {
									condition: (steps, record, isShortLived) => isShortLived == false,
									label: gettext('Enfants'),
									component: 'radio',
									options: [
										{
											label: '0',
											value: 0
										},
										{
											label: '1',
											value: 1
										},
										{
											label: '2',
											value: 2
										},
										{
											label: '3',
											value: 3
										},
										{
											label: '4',
											value: 4
										}
									],
									model: {}
								},
								rma: {
									condition: (steps, record, isShortLived) => isShortLived == false,
									description: gettext('Logement adapté aux personnes à mobilité réduite'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								}
							},
							config: {
								rows: [
									{
										title: gettext('résidences'),
										titleClasses: 'title is-medium is-primary block text-center pb-10 pb-50-md',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form-small',
												repeaterFieldClasses: 'col-form-large',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['residences']
											}
										]
									},
									{
										has_separator: true,
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['starting_date_wish']
											}
										]
									},
									{
										has_separator: true,
										title: gettext('caractéristiques du logement souhaité'),
										titleClasses: 'title is-medium is-primary block text-center pb-10 pb-50-md',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['nb_adults_wish', 'nb_children_wish']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['rma']
											}
										]
									}
								]
							}
						},
						civil_state: {
							endpoint: 'residence-requests/civil-state',
							labelSubmit: gettext('Enregistrer'),
							// title: 'état civil et situation',
							fields: {
								profession_type: {
									label: gettext('Contrat de travail'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {}
								},
								first_name: {
									label: gettext('Prénom'),
									component: 'input',
									model: {},
									validate: 'max:100'
								},
								last_name: {
									label: gettext('Nom'),
									component: 'input',
									model: {},
									validate: 'max:100'
								},
								gender: {
									label: gettext('Sexe'),
									component: 'radio',
									default: '',
									options: [],
									model: {}
								},
								birthday: {
									label: gettext('Date de naissance'),
									component: 'datepicker',
									model: {},
									validate: 'date_format:YYYY-MM-DD'
								},
								marital_status: {
									label: gettext('Situation familiale'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {}
								},
								has_main_home: {
									label: gettext('Avez-vous une résidence principale ?'),
									component: 'radio',
									default: '',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								nb_dependent: {
									label: gettext('Nombre de personnes à charge'),
									component: 'input',
									type: 'number',
									model: {},
									validate: 'max_value:100'
								},
								nationality: {
									label: gettext('Nationalité'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: { value: 'FR' }
								},
								partner: {
									label: gettext('Adulte'),
									component: 'repeater',
									repeat: 1,
									repeaterFields: [
										'first_name',
										'last_name',
										'gender',
										'birthday',
										'marital_status',
										'nb_dependent',
										'nationality',
										'profession_type'
									],
									model: []
								},
								occupants: {
									label: gettext('Enfant'),
									component: 'repeater',
									repeat: 0,
									startIndex: 0,
									repeaterFields: ['first_name', 'last_name', 'gender', 'birthday'],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('situation'),
										titleClasses: 'title is-medium is-primary block text-center pb-10 pb-50-md',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['profession_type']
											}
										]
									},
									{
										has_separator: true,
										title: gettext('état civil'),
										titleClasses: 'title is-medium is-primary block text-center pb-10 pb-50-md',
										classes: '',
										cols: [
											{
												condition: (steps, record) => record.nb_adults_wish == 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['first_name', 'last_name', 'gender', 'birthday']
											},
											{
												condition: (steps, record) => record.nb_adults_wish == 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['marital_status', 'nb_dependent', 'nationality', 'has_main_home']
											},
											{
												condition: (steps, record) => record.nb_adults_wish > 1,
												title: gettext('Adulte 1'),
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'first_name',
													'last_name',
													'gender',
													'birthday',
													'marital_status',
													'nb_dependent',
													'nationality'
												]
											},
											{
												condition: (steps, record) => record.nb_adults_wish > 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['partner']
											}
										]
									},
									{
										has_separator: true,
										condition: (steps, record) => record.nb_children_wish > 0,
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['occupants']
											}
										]
									}
								]
							}
						},
						contact_details: {
							endpoint: 'residence-requests/contact-details',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('coordonnees'),
							fields: {
								addr_number: {
									label: gettext('Numéro de rue'),
									component: 'input',
									model: {},
									validate: 'max:5',
									optional: true
								},
								addr_street: {
									label: gettext('Adresse personnelle'),
									component: 'input',
									model: {}
								},
								addr_zipcode: {
									label: gettext('Code postal'),
									component: 'input',
									model: {},
									validate: 'max:10'
								},
								addr_city: {
									label: gettext('Ville'),
									component: 'input',
									model: {}
								},
								addr_country: {
									label: gettext('Pays (si adresse à l\'étranger)'),
									component: 'input',
									model: {},
									optional: true
								},
								landline_phone_number: {
									label: gettext('Tel domicile'),
									component: 'input',
									type: 'tel',
									model: {},
									optional: true
									// validate: 'phone'
								},
								mobile_phone_number: {
									label: gettext('Tel portable'),
									component: 'input',
									type: 'tel',
									model: {}
									// validate: 'phone',
								},
								email: {
									label: gettext('Email'),
									component: 'input',
									type: 'email',
									model: {},
									validate: 'email',
									readOnly: true
								},
								partner_mobile_phone_number: {
									condition: (steps, record) => record.nb_adults_wish > 1,
									label: gettext('Téléphone conjoint'),
									component: 'input',
									type: 'tel',
									model: {},
									optional: true
									// validate: 'phone'
								},
								partner_email: {
									condition: (steps, record) => record.nb_adults_wish > 1,
									label: gettext('Email conjoint'),
									component: 'input',
									type: 'email',
									model: {},
									optional: true,
									validate: 'email'
								},
								current_accommodation: {
									label: gettext("Type d'hébergement actuel"),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {}
								},
								request_motivation: {
									label: gettext('Motif de la demande'),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {}
								},
								specificities: {
									label: gettext("Préciser les spécificités de l'hébergement si besoin"),
									component: 'input',
									model: {},
									optional: true
								},
								emergency_contact_name: {
									label: gettext('Nom et Prénom'),
									component: 'input',
									model: {},
									optional: true
								},
								emergency_contact_phone_number: {
									label: gettext('Téléphone portable'),
									component: 'input',
									type: 'tel',
									model: {},
									optional: true
									// validate: 'phone'
								},
								emergency_contact_email: {
									label: gettext('Email'),
									component: 'input',
									type: 'email',
									model: {},
									optional: true,
									validate: 'email'
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['addr_number', 'addr_street', 'addr_zipcode', 'addr_city', 'addr_country']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'mobile_phone_number',
													'landline_phone_number',
													'email',
													'partner_mobile_phone_number',
													'partner_email'
												]
											}
										]
									},
									{
										has_separator: true,
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['current_accommodation', 'request_motivation']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['specificities']
											}
										]
									},
									{
										title: gettext("Personne à contacter en cas d'urgence"),
										classes: '',
										cols: [
											{
												fields: ['emergency_contact_name', 'emergency_contact_phone_number']
											},
											{
												fields: ['emergency_contact_email']
											}
										]
									}
								]
							}
						},
						roommate_life: {
							condition: (steps, record) => record.residences.some((el) => (el.is_colocation || el.is_short_lived)),
							endpoint: 'residence-requests/roommate-life',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('vie en colocation'),
							fields: {
								has_already_experienced_house_share: {
									label:
										gettext("Avez-vous déjà vécu en colocation ?"),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								is_ok_to_share_with_opposite_sex: {
									label:
										gettext("Acceptez-vous de partager votre logement avec quelqu'un de sexe différent ?"),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								is_smoker: {
									label: gettext('Êtes-vous fumeur ?'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								is_ok_to_share_with_smoker: {
									label: gettext('Acceptez-vous de partager votre logement avec un fumeur ?'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								has_outside_working_hours: {
									label: gettext('Avez-vous des horaires de travail décalés ?'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								outside_working_hours: {
									label: gettext('Si oui, lequels ?'),
									component: 'input',
									model: {}
								},
								is_ok_to_pay_more_for_private_bathroom: {
									label:
										gettext('Seriez-vous prêt-e à avoir un loyer plus élevé pour avoir une salle de bain privative ?'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								has_already_ask_social_accommodation: {
									label: gettext('Avez-vous déjà réalisé une demande de logement social ?'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								is_ok_to_share_common_areas: {
									label:
										gettext('Êtes-vous prêt à partager des espaces communs (salle de bain, cuisine, WC, salon) avec des colocataires ?'),
									component: 'radio',
									options: [
										{
											label: gettext('oui'),
											value: true
										},
										{
											label: gettext('non'),
											value: false
										}
									],
									model: { value: false }
								},
								social_accommodation_date_application: {
									label: gettext('Si oui, à quelle date ?'),
									component: 'datepicker',
									model: {}
								},
								roommies_other_information: {
									label:
										gettext('Avez-vous des informations particulières, ou des inquiétudes à partager sur le fonctionnement ou la composition de la colocation ?'),
									component: 'textarea',
									model: {},
									optional: true
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-md-9',
												fieldClasses: 'col-md-3 text-right',
												fields: [
													'has_already_experienced_house_share'
												]
											}
										]
									},
									{
										condition: (steps, record, isShortLived) => isShortLived == false && record.residences.some((e) => e.is_colocation),
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-md-9',
												fieldClasses: 'col-md-3 text-right',
												fields: [
													'is_ok_to_share_common_areas'
												]
											}
										]
									},
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-md-9',
												fieldClasses: 'col-md-3 text-right',
												fields: [
													'is_ok_to_share_with_opposite_sex',
													'is_smoker',
													'is_ok_to_share_with_smoker',
													'has_outside_working_hours'
												]
											}
										]
									},
									{
										condition: (steps, record) =>
											steps[0].sections.roommate_life.fields.has_outside_working_hours.model
												.value,
										title: '',
										classes: '',
										cols: [
											{
												labelClasses: 'col-md-6',
												fieldClasses: 'col-md-6',
												fields: ['outside_working_hours']
											}
										]
									},
									{
										condition: (steps, record, isShortLived) => isShortLived == false && record.residences.some((e) => e.is_colocation),
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-md-9',
												fieldClasses: 'col-md-3 text-right',
												fields: [
													'is_ok_to_pay_more_for_private_bathroom',
													'has_already_ask_social_accommodation',
												]
											}
										]
									},
									{
										condition: (steps, record) =>
											steps[0].sections.roommate_life.fields.has_already_ask_social_accommodation
												.model.value,
										title: '',
										classes: '',
										cols: [
											{
												labelClasses: 'col-md-6',
												fieldClasses: 'col-md-6',
												fields: ['social_accommodation_date_application']
											}
										]
									},
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12',
												fields: ['roommies_other_information']
											}
										]
									}
								]
							}
						},
						studies: {
							condition: (steps, record) => studentStatuses.includes(record.profession_type),
							endpoint: 'residence-requests/studies',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('études'),
							fields: {
								profession_type: {
									label: gettext('Type du contrat'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {},
									readOnly: true
								},
								studies: {
									label: gettext('Études suivies'),
									component: 'input',
									model: {}
								},
								studies_level: {
									label: gettext("Niveau d'études"),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {}
								},
								studies_start: {
									label: gettext('Début de la formation'),
									component: 'datepicker',
									model: {}
								},
								studies_last: {
									label: gettext('Durée de la formation'),
									component: 'input',
									model: {}
								},
								studies_establishment: {
									label: gettext("Nom de l'établissement"),
									component: 'input',
									model: {}
								},
								studies_address: {
									label: gettext("Adresse de l'établissement"),
									component: 'input',
									model: {}
								},
								studies_zipcode: {
									label: gettext('Code postal de la formation'),
									component: 'input',
									model: {},
									validate: 'max:10'
								},
								studies_city: {
									label: gettext('Ville de la formation'),
									component: 'input',
									model: {}
								},
								studies_scholarship: {
									label: gettext('Boursier'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {}
								},
								studies_scholarship_amount: {
									condition: (steps, record) =>
										['yes', 'work_in_progress'].includes(
											steps[0].sections.studies.fields.studies_scholarship.model.value
										),
									label: gettext('Montant de la bourse'),
									component: 'input',
									type: 'number',
									model: {},
									validate: 'min_value:1'
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'profession_type',
													'studies_level',
													'studies',
													'studies_start',
													'studies_last'
												]
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'studies_establishment',
													'studies_address',
													'studies_zipcode',
													'studies_city',
													'studies_scholarship',
													'studies_scholarship_amount'
												]
											}
										]
									}
								]
							}
						},
						professional_status: {
							condition: (steps, record) => {
								let professions = [record.profession_type];
								const occupants = record.occupants_obj.filter((el) => el.is_adult);
								if (
									occupants.length &&
									occupants[0].hasOwnProperty('profession_type') &&
									record.nb_adults_wish > 1
								) {
									professions.push(occupants[0].profession_type);
								}
								return professions.some((el) => !unemployedStatuses.includes(el));
							},
							endpoint: 'residence-requests/professional-status',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('situation professionnelle'),
							fields: {
								profession_type: {
									label: gettext('Contrat de travail'),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {},
									readOnly: true
								},
								profession_contract_signature_date: {
									label: gettext("Date d'entrée dans l'entreprise"),
									component: 'datepicker',
									model: {}
								},
								employer_name: {
									label: gettext("Nom de l'entreprise"),
									component: 'input',
									model: {}
								},
								profession_from_form: {
									label: gettext('Profession'),
									component: 'input',
									model: {}
								},
								employer_addr: {
									label: gettext('Adresse de votre lieu de travail'),
									component: 'input',
									model: {}
								},
								employer_addr_zipcode: {
									label: gettext('Code postal'),
									component: 'input',
									model: {},
									validate: 'max:10'
								},
								employer_addr_city: {
									label: gettext('Ville'),
									component: 'input',
									model: {}
								},
								employer_id: {
									label: gettext("Numéro de SIRET de l'entreprise"),
									component: 'input',
									validate: 'length:14|numeric',
									model: {},
									optional: true
								},
								partner: {
									label: gettext('Adulte'),
									component: 'repeater',
									repeat: 1,
									repeaterFields: [
										'profession_type',
										'profession_contract_signature_date',
										'profession_from_form',
										'employer_name',
										// 'employer_addr',
										'employer_addr_zipcode',
										'employer_addr_city',
										'employer_id'
									],
									fieldsOptionals: [
										'profession_contract_signature_date',
										'profession_from_form',
										'employer_name',
										// 'employer_addr',
										'employer_addr_zipcode',
										'employer_addr_city',
										'employer_id'
									],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												condition: (steps, record) => record.nb_adults_wish == 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'profession_type',
													'profession_contract_signature_date',
													'profession_from_form',
													'employer_name'
												]
											},
											{
												condition: (steps, record) => record.nb_adults_wish == 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													// 'employer_addr',
													'employer_addr_zipcode',
													'employer_addr_city',
													'employer_id'
												]
											},
											{
												condition: (steps, record) =>
													record.nb_adults_wish > 1 &&
													!unemployedStatuses.includes(record.profession_type),
												title: gettext('Adulte 1'),
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'profession_type',
													'profession_contract_signature_date',
													'profession_from_form',
													'employer_name',
													// 'employer_addr',
													'employer_addr_zipcode',
													'employer_addr_city',
													'employer_id'
												]
											},
											{
												condition: (steps, record) =>
													record.nb_adults_wish > 1 &&
													!unemployedStatuses.includes(
														record.occupants_obj.filter((el) => el.is_adult)[0]
															.profession_type
													),
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['partner']
											}
										]
									}
								]
							}
						},
						commuting: {
							endpoint: 'residence-requests/commuting',
							labelSubmit: gettext('Étape suivante'),
							title: gettext("Mon trajet domicile-travail ou lieu d'études"),
							fields: {
								weekly_accommodation: {
									label: gettext('Où êtes-vous logé en semaine ?'),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {},
									optional: true
								},
								commuting_time_hours: {
									label: gettext("Quel est votre temps de trajet domicile - travail (ou lieu d'études) actuellement ?"),
									component: 'select',
									default: 'Sélectionner',
									options: [{
										value: '0',
										label: '0h'
									}, {
										value: 1,
										label: '1h'
									}, {
										value: 2,
										label: '2h'
									}, {
										value: 3,
										label: '3h'
									}],
									model: {},
									optional: true
								},
								commuting_time_minutes: {
									label: '                  ',
									component: 'select',
									default: 'Sélectionner',
									options: [{
										value: '0',
										label: '00m'
									}, {
										value: 5,
										label: '05m'
									}, {
										value: 10,
										label: '10m'
									}, {
										value: 15,
										label: '15m'
									}, {
										value: 20,
										label: '20m'
									}, {
										value: 25,
										label: '25m'
									}, {
										value: 30,
										label: '30m'
									}, {
										value: 35,
										label: '35m'
									}, {
										value: 40,
										label: '40m'
									}, {
										value: 45,
										label: '45m'
									}, {
										value: 50,
										label: '50m'
									},
									{
										value: 55,
										label: '55m'
									}],
									model: { value: 0 },
									optional: true
								},
								commuting_transportation: {
									label: gettext("Quel est votre mode de transport (principal) pour vous y rendre actuellement ?"),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {},
									optional: true
								},
								future_commuting_time_hours: {
									label: gettext("Quel sera votre temps de trajet domicile - travail (ou lieu d'études) si vous logez dans une résidence Résidétape ?"),
									component: 'select',
									default: 'Sélectionner',
									options: [{
										value: '0',
										label: '0h'
									}, {
										value: 1,
										label: '1h'
									}, {
										value: 2,
										label: '2h'
									}, {
										value: 3,
										label: '3h'
									}],
									model: {},
								},
								future_commuting_time_minutes: {
									label: '                 ',
									component: 'select',
									default: 'Sélectionner',
									options: [{
										value: '0',
										label: '00m'
									}, {
										value: 5,
										label: '05m'
									}, {
										value: 10,
										label: '10m'
									}, {
										value: 15,
										label: '15m'
									}, {
										value: 20,
										label: '20m'
									}, {
										value: 25,
										label: '25m'
									}, {
										value: 30,
										label: '30m'
									}, {
										value: 35,
										label: '35m'
									}, {
										value: 40,
										label: '40m'
									}, {
										value: 45,
										label: '45m'
									}, {
										value: 50,
										label: '50m'
									},
									{
										value: 55,
										label: '55m'
									}],
									model: {},
									optional: true
								},
								future_commuting_transportation: {
									label: gettext('Quel sera votre mode de transport (principal) pour vous y rendre si vous logez dans une résidence Résidétape ?'),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {},
								},

							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['commuting_time_hours', 'commuting_time_minutes']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['future_commuting_time_hours', 'future_commuting_time_minutes']
											}
										]
									},
									{
										has_separator: true,
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['commuting_transportation']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['future_commuting_transportation']
											}
										]
									},
									{
										has_separator: true,
										condition: (steps, record, isShortLived) => isShortLived == true,
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['weekly_accommodation']
											}
										]
									},
								]
							}
						},
						resources: {
							endpoint: 'residence-requests/resources',
							labelSubmit: gettext('Étape suivante'),
							title: gettext('ressources'),
							fields: {
								incomes_monthly: {
									label: gettext('Salaire mensuel net actuel'),
									component: 'input',
									type: 'number',
									model: {}
								},
								activity_bonus: {
									label: gettext("Prime d'activité"),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								family_allocations: {
									label: gettext('Allocations familiales'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								incomes_other: {
									label: gettext('Autres revenus mensuels justifiables'),
									component: 'select',
									default: 'Sélectionner',
									options: [],
									model: {},
									optional: true
								},
								incomes_other_amount: {
									label: gettext('Montant'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								incomes_n2: {
									label: gettext('Revenu fiscal ') + (new Date().getFullYear() - 2),
									component: 'input',
									type: 'number',
									model: {}
								},
								partner: {
									label: gettext('Adulte'),
									component: 'repeater',
									repeat: 1,
									repeaterFields: ['incomes_monthly'],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												condition: (steps, record) => record.nb_adults_wish == 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['incomes_monthly']
											},
											{
												condition: (steps, record, isShortLived) => isShortLived == false && record.nb_adults_wish == 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['incomes_n2']
											},
											{
												condition: (steps, record) => record.nb_adults_wish > 1,
												title: gettext('Adulte 1'),
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['incomes_monthly']
											},
											{
												condition: (steps, record) => record.nb_adults_wish > 1,
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['partner']
											}
										]
									},
									{
										has_separator: true,
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['activity_bonus', 'family_allocations']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['incomes_other', 'incomes_other_amount']
											}
										]
									}
								]
							}
						}
					}
				},
				{
					name: gettext('motivations'),
					description: '',
					activeSection: 'motivations',
					sections: {
						motivations: {
							endpoint: 'residence-requests/motivations',
							labelSubmit: gettext('Étape suivante'),
							fields: {
								motivations: {
									label:
										gettext('Pourquoi souhaitez-vous faire une demande de logement dans une Résidétape ?'),
									component: 'textarea',
									model: {},
									optional: true
								},
								knows_residetape_from: {
									label: gettext('Comment avez-vous connu Résidétape ?'),
									component: 'select',
									default: gettext('Sélectionner un choix'),
									options: [],
									model: {}
								},
								knows_residetape_from_extra: {
									condition: (steps, record) =>
										['association', 'internet_research'].includes(
											steps[1].sections.motivations.fields.knows_residetape_from.model.value
										),
									label: gettext('Merci de préciser laquelle'),
									component: 'input',
									model: {},
									optional: true
								}
							},
							config: {
								no_frame: true,
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12 pb-20',
												fieldClasses: 'col-12',
												fields: ['motivations']
											}
										]
									},
									{
										title: '',
										classes: 'pt-30',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-md-6',
												fieldClasses: 'col-md-6',
												fields: ['knows_residetape_from', 'knows_residetape_from_extra']
											}
										]
									}
								]
							}
						}
					}
				},
				{
					name: gettext('pièces à fournir'),
					// description: 'Donec ullamcorper nulla non metus auctor fringilla. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Nulla vitae elit libero, a pharetra augue.',
					activeSection: 'documents_resident_civil_state',
					sections: {
						documents_resident_civil_state: {
							labelSubmit: gettext('Enregistrer'),
							fields: {
								civil_state: {
									label:
										doc_civil_state,
									// gettext("Copie de la carte d'identité recto verso, ou du passeport, ou de la carte de séjour en cours de validité."),
									maxFiles: 2,
									component: 'file-zone',
									referrer: 'resident',
									model: [],
									mandatory: true
								}
							},
							config: {
								rows: [
									{
										title: gettext('etat civil'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['civil_state']
											}
										]
									}
								]
							}
						},
						documents_resident_income: {
							condition: (steps, record) => !record.residences.some(el => el.is_short_lived),
							labelSubmit: gettext('Enregistrer'),
							// title: '',
							fields: {
								income: {
									label:
										doc_income,
									// gettext("Copie de votre avis d'imposition ou de non imposition ") +
									// (new Date().getFullYear() - 1) +
									// gettext('(sur les revenus ') +
									// (new Date().getFullYear() - 2) +
									// gettext(") ou déclaration sur l'honneur de non revenu en ") +
									// (new Date().getFullYear() - 2),
									maxFiles: 3,
									component: 'file-zone',
									referrer: 'resident',
									model: [],
									mandatory: true
								}
							},
							config: {
								rows: [
									{
										title: gettext('imposition'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['income']
											}
										]
									}
								]
							}
						},
						documents_resident_rental: {
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								rental: {
									label:
										doc_rental,
									// gettext("Vos 3 dernières quittances de loyer ou une attestation d'hébergement avec justificatif : dernière quittance de loyer de l’hébergeant s’il est locataire ou dernier avis de axe foncière s’il est propriétaire"),
									maxFiles: 3,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('logement actuel'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['rental']
											}
										]
									}
								]
							}
						},
						// documents_resident_iban: {
						// 	labelSubmit: gettext('Enregistrer ou Passer'),
						// 	// title: '',
						// 	fields: {
						// 		iban: {
						// 			label: doc_iban,
						// 			// gettext('RIB ou IBAN-BIC de votre banque'),
						// 			maxFiles: 1,
						// 			component: 'file-zone',
						// 			referrer: 'resident',
						// 			model: []
						// 		}
						// 	},
						// 	config: {
						// 		rows: [
						// 			{
						// 				title: gettext('coordonnées bancaires'),
						// 				titleClasses: 'title is-medium is-gray-800',
						// 				classes: '',
						// 				cols: [
						// 					{
						// 						classes: 'col-form-large',
						// 						labelClasses: 'col-12',
						// 						fieldClasses: 'col-12 pt-30',
						// 						fields: ['iban']
						// 					}
						// 				]
						// 			}
						// 		]
						// 	}
						// },
						documents_resident_job_contract: {
							condition: (steps, record) => !unemployedStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								job_contract: {
									label: doc_job_contract,
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('contrat de travail'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['job_contract']
											}
										]
									}
								]
							}
						},
						documents_resident_employer_attestation: {
							condition: (steps, record) => !unemployedStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								employer_attestation: {
									label:
										doc_employer_attestation,
									// gettext("Mentionnant l'emploi, le salaire net et le type de contrat, précisant que vous n’êtes pas en procédure de licenciement ou en période de préavis"),
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext("attestation de l'employeur"),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['employer_attestation']
											}
										]
									}
								]
							}
						},
						documents_resident_salary: {
							condition: (steps, record) => !unemployedStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								salary: {
									label: doc_salary,
									maxFiles: 3,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('3 derniers bulletins de salaire'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['salary']
											}
										]
									}
								]
							}
						},
						documents_resident_other_income: {
							condition: (steps, record) => !unemployedStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								other_income: {
									label:
										doc_other_income,
									// gettext('Versement des prestations familiales, pension alimentaire, attestation de bourse'),
									maxFiles: 4,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('pièces justificatives des autres ressources'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['other_income']
											}
										]
									}
								]
							}
						},
						documents_resident_scolarity_certificate: {
							condition: (steps, record) => studentStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								scolarity_certificate: {
									label: doc_scolarity_certificate,
									// gettext('Copie du certificat de scolarité'),
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('copie du certificat de scolarité'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['scolarity_certificate']
											}
										]
									}
								]
							}
						},
						documents_resident_student_card: {
							condition: (steps, record) => studentStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								student_card: {
									label: doc_student_card,
									// gettext("Copie de la carte d'étudiant"),
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext("copie de la carte d'étudiant"),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['student_card']
											}
										]
									}
								]
							}
						},
						documents_resident_scholarship: {
							condition: (steps, record) => studentStatuses.includes(record.profession_type),
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								scholarship: {
									label: doc_scolarship,
									// gettext('Attestation de bourse'),
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'resident',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('attestation de bourse'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['scholarship']
											}
										]
									}
								]
							}
						}
					}
				},
				... !this.isShortLived ? [{
					name: gettext('garantie'),
					activeSection: 'guarantors_civil_state',
					sections: {
						guarantors_type_choice: {
							endpoint: 'residence-requests/guarantors-type',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('Type de garantie'),
							description: gettext(`
							<strong>Si cela est possible, Résidétape vous aide à mobiliser une garantie adaptée à votre profil :</strong><br><br>

<strong>1.</strong> D’abord, vérifiez si vous êtes éligible à Visale, une garantie proposée gratuitement par Action Logement Services.
Si vous avez entre 18 et 30 ans inclus, que vous êtes en intérim, en CDD, en CDI (y compris en période d'essai ou au stade de la lettre d'embauche), alors vous pouvez prétendre à Visale !
Nous vous invitons à faire dès à présent votre demande de « visa » sur le site <a href="https://www.visale.fr" target="_blank">www.visale.fr</a>, et à joindre le visa certifié à votre demande. Nous en aurons besoin si nous vous proposons un entretien en vue d'approfondir votre demande, et elle pourra vous servir dans vos démarches de recherche de logement.<br><br>

<strong>2.</strong> Pour les candidats préférant présenter un garant physique (résidant en France), merci de l’indiquer ci-dessous, et de renseigner les informations demandées sur votre garant.<br><br>

<strong>3.</strong> Pour les candidats préférant présenter un autre garant : association, employeur, dispositif autre (FSH, CLE), merci de l’indiquer ci-dessous, ainsi que toute précision utile.
`),
							fields: {
								guarantor_type: {
									label: gettext('Type de garantie'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {}
								},
								guarantor_details: {
									label:
										gettext("Avez-vous des informations particulières à notifier pour l'application de votre garantie ? (exemple : numéro du visa Visale)"),
									component: 'textarea',
									optional: true,
									model: {}
								}
							},
							config: {
								rows: [
									{
										title: '',
										titleClasses: 'title is-medium is-primary block text-center pb-10 pb-50-md',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantor_type']
											}
										]
									},
									{
										condition: (steps, record) =>
											guarantorTypes.includes(
												steps[3].sections['guarantors_type_choice'].fields.guarantor_type.model
													.value
											),
										has_separator: true,
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantor_details']
											}
										]
									}
								]
							}
						},
						guarantors_civil_state: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							endpoint: 'residence-requests/guarantors-civil-state',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('coordonnées'),
							fields: {
								first_name: {
									label: gettext('Prénom'),
									component: 'input',
									model: {}
								},
								last_name: {
									label: gettext('Nom'),
									component: 'input',
									model: {}
								},
								kinship: {
									label: gettext('Lien de parenté'),
									component: 'input',
									model: {},
									optional: true
								},
								birthday: {
									label: gettext('Date de naissance'),
									component: 'datepicker',
									model: {},
									optional: true,
									validate:
										'date_format:YYYY-MM-DD|date_between:' +
										getDate(-100 * 365) +
										',' +
										getDate(-16 * 365)
								},
								gender: {
									label: gettext('Sexe'),
									component: 'radio',
									default: '',
									options: [],
									model: {},
									optional: true
								},
								nationality: {
									label: gettext('Nationalité'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: { value: 'FR' },
									optional: true
								},
								marital_status: {
									label: gettext('Situation familiale'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {},
									optional: true
								},
								guarantors: {
									label: gettext('Garant'),
									component: 'repeater',
									repeat: 2,
									startIndex: 0,
									nextFieldsOptionals: true,
									repeaterFields: [
										'first_name',
										'last_name',
										// 'kinship',
										'birthday',
										'gender',
										'nationality',
										'marital_status'
									],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantors']
											}
										]
									}
								]
							}
						},
						guarantors_contact_details: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							endpoint: 'residence-requests/guarantors-contact-details',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('coordonnées'),
							fields: {
								addr_number_street: {
									label: gettext('Adresse personnelle'),
									component: 'input',
									model: {}
								},
								addr_zipcode: {
									label: gettext('Code postal'),
									component: 'input',
									model: {},
									validate: 'max:10'
								},
								addr_city: {
									label: gettext('Ville'),
									component: 'input',
									model: {}
								},
								landline_phone_number: {
									label: gettext('Téléphone domicile'),
									component: 'input',
									type: 'tel',
									model: {},
									optional: true
								},
								mobile_phone_number: {
									label: gettext('Téléphone portable'),
									component: 'input',
									type: 'tel',
									model: {}
									// validate: 'phone',
								},
								email: {
									label: gettext('Email'),
									component: 'input',
									type: 'email',
									model: {},
									validate: 'email'
								},
								guarantors: {
									label: gettext('Garant'),
									component: 'repeater',
									repeat: 2,
									startIndex: 0,
									nextFieldsOptionals: true,
									repeaterFields: [
										'addr_number_street',
										'addr_zipcode',
										'addr_city',
										'landline_phone_number',
										'mobile_phone_number',
										'email'
									],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantors']
											}
										]
									}
								]
							}
						},
						guarantors_professional_status: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							endpoint: 'residence-requests/guarantors-professional-status',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('situation professionnelle'),
							fields: {
								profession_type: {
									label: gettext('Contrat de travail'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {},
									optional: true
								},
								employer_date: {
									label: gettext("Date d'entrée dans l'entreprise"),
									component: 'datepicker',
									model: {},
									optional: true
								},
								employer_name: {
									label: gettext("Nom de l'entreprise"),
									component: 'input',
									model: {},
									optional: true
								},
								profession_name: {
									label: gettext('Profession'),
									component: 'input',
									model: {},
									optional: true
								},
								employer_addr: {
									label: gettext('Adresse de votre lieu de travail'),
									component: 'input',
									model: {},
									optional: true
								},
								employer_addr_zipcode: {
									label: gettext('Code postal'),
									component: 'input',
									model: {},
									optional: true,
									validate: 'max:10'
								},
								employer_addr_city: {
									label: gettext('Ville'),
									component: 'input',
									model: {},
									optional: true
								},
								guarantors: {
									label: gettext('Garant'),
									component: 'repeater',
									repeat: 2,
									startIndex: 0,
									nextFieldsOptionals: true,
									repeaterFields: [
										'profession_type',
										// 'employer_date',
										'employer_name'
										// 'profession_name',
										// 'employer_addr',
										// 'employer_addr_zipcode',
										// 'employer_addr_city'
									],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantors']
											}
										]
									}
								]
							}
						},
						guarantors_resources: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							endpoint: 'residence-requests/guarantors-resources',
							labelSubmit: gettext('Enregistrer'),
							title: gettext('ressources'),
							fields: {
								incomes_monthly: {
									label: gettext('Salaire mensuel net'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								guarantor_incomes_n1: {
									label: gettext('Revenu fiscal de référence ') + (new Date().getFullYear() - 1),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								guarantor_incomes_n2: {
									label: gettext('Revenu fiscal de référence ') + (new Date().getFullYear() - 2),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								family_grant: {
									label: gettext('Allocations familiales'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								tenement_grant: {
									label: gettext('APL ou allocation logement'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								guarantor_incomes_other: {
									label: gettext('Autres revenus mensuels justifiables'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {},
									optional: true
								},
								guarantor_incomes_other_amount: {
									condition: (steps, record) =>
										steps[3].sections.guarantors_resources.fields.guarantor_incomes_other.model
											.value !== '',
									label: gettext('Montant'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								guarantor_incomes_other_bis: {
									label: gettext('Autres revenus mensuels justifiables'),
									component: 'select',
									default: gettext('Sélectionner'),
									options: [],
									model: {},
									optional: true
								},
								guarantor_incomes_other_amount_bis: {
									condition: (steps, record) =>
										steps[3].sections.guarantors_resources.fields.guarantor_incomes_other_bis.model
											.value !== '',
									label: gettext('Montant'),
									component: 'input',
									type: 'number',
									model: {},
									optional: true
								},
								guarantors: {
									label: gettext('Garant'),
									component: 'repeater',
									repeat: 2,
									startIndex: 0,
									nextFieldsOptionals: true,
									repeaterFields: ['incomes_monthly'],
									model: []
								}
							},
							config: {
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												repeaterClasses: 'col-form',
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantors']
											}
										]
									},
									{
										has_separator: true,
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantor_incomes_n2']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantor_incomes_n1']
											}
										]
									},
									{
										title: '',
										classes: '',
										cols: [
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: ['guarantor_incomes_other', 'guarantor_incomes_other_amount']
											},
											{
												// labelClasses: '',
												// fieldClasses: '',
												fields: [
													'guarantor_incomes_other_bis',
													'guarantor_incomes_other_amount_bis'
												]
											}
										]
									}
								]
							}
						},
						documents_guarantors_visale: {
							condition: (steps, record) => record.guarantor_type === 'visale',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								visale: {
									label: gettext('Copie du visa certifié Visale'),
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('Copie du visa certifié Visale'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['visale']
											}
										]
									}
								]
							}
						},
						documents_guarantors_civil_state: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								civil_state: {
									label:
										doc_civil_state_guarantors,
									// gettext("Copie de la carte d'identité recto verso, ou du passeport, ou de la carte de séjour en cours de validité."),
									maxFiles: 2,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('pièce(s) d’identité'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['civil_state']
											}
										]
									}
								]
							}
						},
						documents_guarantors_income: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								income: {
									label:
										doc_income_guarantors,
									// gettext("Copie des avis d'imposition ou de non imposition sur le revenu N-2 et N-1, ou copie de la déclaration avec avis d'envoi à la Poste, ou déclaration sur l'honneur de non revenu."),
									maxFiles: 3,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('imposition'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['income']
											}
										]
									}
								]
							}
						},
						documents_guarantors_rental: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								rental: {
									label:
										doc_rental_guarantors,
									// gettext("Les 3 dernières quittances de loyer ou une attestation d'hébergement avec justificatif : dernière quittance de loyer de l’hébergeant s’il est locataire ou dernier avis de axe foncière s’il est propriétaire"),
									maxFiles: 3,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('logement actuel'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['rental']
											}
										]
									}
								]
							}
						},
						// documents_guarantors_iban: {
						// 	condition: (steps, record) => record.guarantor_type === 'physical',
						// 	labelSubmit: gettext('Enregistrer ou Passer'),
						// 	// title: '',
						// 	fields: {
						// 		iban: {
						// 			label: gettext('RIB ou IBAN-BIC de votre banque'),
						// 			maxFiles: 1,
						// 			component: 'file-zone',
						// 			referrer: 'guarantor',
						// 			model: []
						// 		}
						// 	},
						// 	config: {
						// 		rows: [
						// 			{
						// 				title: gettext('coordonnées bancaires'),
						// 				titleClasses: 'title is-medium is-gray-800',
						// 				classes: '',
						// 				cols: [
						// 					{
						// 						classes: 'col-form-large',
						// 						labelClasses: 'col-12',
						// 						fieldClasses: 'col-12 pt-30',
						// 						fields: [ 'iban' ]
						// 					}
						// 				]
						// 			}
						// 		]
						// 	}
						// },
						documents_guarantors_job_contract: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								job_contract: {
									label: doc_job_contract_guarantors,
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('contrat(s) de travail'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['job_contract']
											}
										]
									}
								]
							}
						},
						documents_guarantors_employer_attestation: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								employer_attestation: {
									label:
										doc_employer_attestation_guarantors,
									// gettext("mentionnant l'emploi, le salaire net et le type de contrat, précisant que vous n'êtes pas en procédure de licenciement ou en période de préavis"),
									maxFiles: 1,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext("attestation(s) de l'employeur"),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['employer_attestation']
											}
										]
									}
								]
							}
						},
						documents_guarantors_salary: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Enregistrer ou Passer'),
							// title: '',
							fields: {
								salary: {
									label: doc_salary_guarantors,
									maxFiles: 6,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('3 derniers bulletins de salaire'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['salary']
											}
										]
									}
								]
							}
						},
						documents_guarantors_other_income: {
							condition: (steps, record) => record.guarantor_type === 'physical',
							labelSubmit: gettext('Étape suivante ou Passer'),
							// title: '',
							fields: {
								other_income: {
									label: doc_other_income_guarantors,
									// gettext('versement des prestations familiales, pension alimentaire'),
									maxFiles: 4,
									component: 'file-zone',
									referrer: 'guarantor',
									model: []
								}
							},
							config: {
								rows: [
									{
										title: gettext('pièces justificatives des autres ressources'),
										titleClasses: 'title is-medium is-gray-800',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												labelClasses: 'col-12',
												fieldClasses: 'col-12 pt-30',
												fields: ['other_income']
											}
										]
									}
								]
							}
						}
					}
				}] : [],
				{
					name: gettext('envoi'),
					activeSection: 'send_application',
					sections: {
						send_application: {
							endpoint: 'residents/{resident_id}/send-application',
							labelSubmit: gettext('Valider mon dossier de candidature'),
							title: '',
							fields: {
								check_validation: {
									label: '',
									component: 'checkbox',
									option:
										gettext("Je certifie sur l'honneur l'exactitude des renseignements de ce formulaire, et des pièces demandées jointes à mon dossier ou envoyées par courrier, et m'engage à faire connaitre tout changement pouvant intervenir dans ma situation"),
									model: {}
								},
								check_rgpd: {
									label: '',
									component: 'checkbox',
									option: gettext(`Les informations recueillies par Résidétapes Développement (Résidétape) dans le cadre de votre demande de logement, et si vous devenez résident, leur actualisation tout au long de votre séjour font l’objet d’un traitement informatique en conformité avec l’article 6 alinéa 2 de la loi « relative à l'informatique, aux fichiers et aux libertés » du 6 janvier 1978.<br><br>Ce traitement informatique est destiné aux services de gestion des résidences et du siège, dans la finalité de servir aux missions d’instruction des demandes de logement, de suivi locatif, social, comptable et technique de votre séjour le cas échéant, de développement des résidences et de gestion du fonds de dotation. Ces données seront conservées durant maximum 5 ans à compter de notre dernier contact.<br><br>Conformément aux articles 15, 16 et 17 de la loi « relative à l'informatique, aux fichiers et aux libertés » du 6 janvier 1978, vous disposez d’un droit d’accès, d’opposition, de vérification, de rectification et d’effacement des informations qui vous concernent.<br><br>Vous pouvez accéder à ces informations sur votre compte en ligne pendant toute la durée de votre candidature, puis si vous devenez résident, en vous adressant par courriel à dpo@residetape.fr ou par courrier à l’adresse suivante : Délégué à la Protection des Données, Résidétapes Développement, 17 avenue Desgenettes, 94100 Saint-Maur-des-Fossés, sous réserve de joindre un justificatif d’identité à votre demande.<br><br>Conformément à l’article 11 de la loi « informatique et libertés » du 6 janvier 1978 modifiée, et en cas de non-respect de votre droit à la confidentialité de vos données personnelles, la Commission nationale de l’informatique et des libertés est habilitée à recevoir des plaintes relatives à la mise en œuvre des traitements de données à caractère personnel.`),
									model: {}
								}
							},
							config: {
								no_frame: true,
								rows: [
									{
										title: '',
										classes: '',
										cols: [
											{
												classes: 'col-form-large',
												// title:'',
												// labelClasses: '',
												fieldClasses: 'col-12',
												fields: ['check_validation', 'check_rgpd']
											}
										]
									}
								]
							}
						}
					}
				}]
			},
			updateRecord(data) {
				this.record = {
					...data,
					commuting_time_hours: data.commuting_time_hours == 0 ? '0' : data.commuting_time_hours,
					commuting_time_minutes: data.commuting_time_minutes == 0 ? '0' : data.commuting_time_minutes,
					future_commuting_time_hours: data.future_commuting_time_hours == 0 ? '0' : data.future_commuting_time_hours,
					future_commuting_time_minutes: data.future_commuting_time_minutes == 0 ? '0' : data.future_commuting_time_minutes,
				};
				this.record.residences = this.recordResidences;
				this.steps.forEach((step, stepIndex) => {
					Object.keys(this.steps[stepIndex].sections).forEach((sectionKey) => {
						// if (sectionKey == this.record['application_form_furthest_step']) {
						//   // this.currentStep = stepIndex;
						//   // this.steps[stepIndex].activeSection = sectionKey;
						//   this.changeSection(sectionKey)
						// }
						Object.keys(this.record).forEach((fieldKey) => {
							// console.log(fieldKey)
							let section = this.steps[stepIndex].sections[sectionKey];
							if (
								fieldKey in section.fields ||
								(fieldKey == 'occupants' && section.fields.hasOwnProperty('partner'))
							) {
								if (fieldKey == 'occupants') {
									let model_occupants = [];
									let model_partner = [];
									this.record['occupants_obj'].forEach((row, index) => {
										// console.log(row);
										if (row['is_adult']) {
											let obj = {};
											Object.keys(row).forEach((key) => {
												if (section.fields['partner'].repeaterFields.includes(key)) {
													obj[key] = { value: row[key] };
												}
											});
											obj['id'] = row['id'];
											model_partner.push(obj);
										} else if (section.fields.hasOwnProperty('occupants')) {
											let obj = {};
											Object.keys(row).forEach((key) => {
												if (section.fields['occupants'].repeaterFields.includes(key)) {
													obj[key] = { value: row[key] };
												}
											});
											obj['id'] = row['id'];
											model_occupants.push(obj);
										}
									});
									// console.log(model_partner);
									// console.log(model_occupants);
									if (section.fields.hasOwnProperty('partner')) {
										section.fields['partner'].model = model_partner;
									}
									if (section.fields.hasOwnProperty('occupants')) {
										section.fields['occupants'].model = model_occupants;
									}
								} else if (fieldKey == 'guarantors') {
									let model_guarantors = [];
									this.record['guarantors_obj'].forEach((row, index) => {
										// console.log(row);
										let obj = {};
										Object.keys(row).forEach((key) => {
											if (section.fields['guarantors'].repeaterFields.includes(key)) {
												obj[key] = { value: row[key] };
											} else if (['id', 'is_main'].includes(key)) {
												obj[key] = row[key];
											} else if (
												section.fields.hasOwnProperty('guarantor_' + key) &&
												row['is_main']
											) {
												// console.log(row[key]);
												if (
													section.fields['guarantor_' + key].hasOwnProperty('options') &&
													!section.fields['guarantor_' + key].options.length &&
													this.dropdowns.hasOwnProperty('guarantor_incomes_other')
												) {
													section.fields['guarantor_' + key].options = this.dropdowns[
														'guarantor_incomes_other'
													].options;
												}
												section.fields['guarantor_' + key].model = { value: row[key] };
											}
										});
										// console.log('guarantor', obj)
										if (row['is_main']) {
											model_guarantors.splice(0, 0, obj);
										} else {
											model_guarantors.push(obj);
										}
									});
									// console.log('section', section.title)
									// console.log(model_guarantors)
									section.fields['guarantors'].model = model_guarantors;
								} else if (fieldKey == 'residences') {
									// console.log('hello');

									let model_residences = [];

									if (
										section.fields['residence'].hasOwnProperty('options') &&
										!section.fields['residence'].options.length &&
										this.dropdowns.hasOwnProperty('residence')
									) {
										// console.log('populate dropdowns residences');
										section.fields['residence'].options = this.dropdowns['residence'].options;
									}

									this.record['residences'].forEach((row, index) => {
										// console.log('row', row);
										let obj = {};
										obj.residence = { value: row.id };
										model_residences.push(obj);
									});
									// console.log(model_residences);
									section.fields['residences'].model = model_residences;
								} else if (fieldKey == 'future_commuting_transportation') {
									section.fields['future_commuting_transportation'].options = this.dropdowns['commuting_transportation'].options;
									section.fields['future_commuting_transportation'].model = { value: this.record['future_commuting_transportation'] }
								} else {
									// console.log(fieldKey)
									if (
										section.fields[fieldKey].hasOwnProperty('options') &&
										!section.fields[fieldKey].options.length &&
										this.dropdowns.hasOwnProperty(fieldKey)
									) {
										section.fields[fieldKey].options = this.dropdowns[fieldKey].options;
									}
									section.fields[fieldKey].model = { value: this.record[fieldKey] };
								}
							}
						});
					});
				});
				this.setOccupants();
			},
			setFurthestSection() {
				this.steps.forEach((step, stepIndex) => {
					Object.keys(this.steps[stepIndex].sections).forEach((sectionKey) => {
						if (
							sectionKey === this.record['application_form_furthest_step'] &&
							sectionKey !== 'appartment_characteristics'
						) {
							console.log(sectionKey)
							this.currentStep = stepIndex;
							this.changeSection(sectionKey, true);
						}
					});
				});
			},
			getRecord() {
				return axios
					.all([
						this.get('residents/' + this.residentId),
						this.get('residence-requests?resident=' + this.residentId)
					])
					.then(
						axios.spread((record, residences) => {
							this.isShortLived = record.data.is_short_lived
							this.recordResidences = residences.data.results.map((el) => ({
								id: el.residence,
								is_colocation: el.residence_obj.is_colocation,
								is_short_lived: el.residence_obj.is_short_lived
							}));
							const residencesUrl = `dropdowns/residence-list${record.data.is_short_lived ? '?short-lived=1' : ''}`
							axios.all([this.get('dropdowns/all'), this.get(residencesUrl)]).then(
								axios.spread((dropdowns, residences) => {
									this.dropdowns = dropdowns.data;

									this.dropdowns.residence = {
										options: residences.data.map(
											(el) => (residences.data[el] = { label: el.label, value: el.value })
										)
									};
									this.setData();
									this.updateRecord(record.data);
									setTimeout(() => {
										this.setFurthestSection();
									}, 1000)
								})
							)
						})
					);
			},
			getDropdowns() {
				const residencesUrl = `dropdowns/residence-list${this.isShortLived ? '?short-lived=0' : ''}`
				return axios.all([this.get('dropdowns/all'), this.get(residencesUrl)]).then(
					axios.spread((dropdowns, residences) => {
						this.dropdowns = dropdowns.data;

						this.dropdowns.residence = {
							options: residences.data.map(
								(el) => (residences.data[el] = { label: el.label, value: el.value })
							)
						};
					})
				);
			},
			getDocs() {
				this.get('documents?resident=' + this.residentId)
					.then((response) => {
						this.documents = response.data.results;
						this.steps.forEach((step, stepIndex) => {
							Object.keys(this.steps[stepIndex].sections).forEach((sectionKey) => {
								let section = this.steps[stepIndex].sections[sectionKey];
								Object.keys(section.fields).forEach((fieldKey) => {
									// console.log(fieldKey)
									if (
										section.fields[fieldKey].component == 'file-zone' &&
										section.fields[fieldKey].referrer == 'resident'
									) {
										let files = [];
										this.documents.forEach((doc) => {
											if (doc.document_type == fieldKey && doc.guarantor === null) {
												files.push(doc);
											}
										});
										section.fields[fieldKey].model = files;
									} else if (
										section.fields[fieldKey].component == 'file-zone' &&
										section.fields[fieldKey].referrer == 'guarantor'
									) {
										let files = [];
										this.documents.forEach((doc) => {
											if (doc.document_type == fieldKey && doc.guarantor !== null) {
												files.push(doc);
											}
										});
										section.fields[fieldKey].model = files;
									}
								});
							});
						});
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getSection(sectionKey) {
				return this.steps[this.currentStep].sections[sectionKey];
			},
			getActiveSection() {
				return this.steps[this.currentStep].sections[this.steps[this.currentStep].sections.activeSection];
			},
			getActiveSectionKey() {
				return this.steps[this.currentStep].activeSection;
			},
			sectionClass(section, key) {
				let classArray = [];
				if (key == this.getActiveSectionKey()) {
					classArray.push('is-active');
				}
				if (!section.config.no_frame) {
					classArray.push('has-frame');
				}

				return classArray;
			},
			setOccupants() {
				this.steps[0].sections.civil_state.fields.occupants.repeat = this.record.nb_children_wish;
			},
			updateSteps(direction = 1) {
				if (this.currentStep + direction >= 0) {
					this.currentStep += direction;
					// console.log(this.currentStep);
					let sections = this.steps[this.currentStep].sections;
					let filteredSections = Object.keys(sections).filter((section) => {
						if (sections[section].hasOwnProperty('condition')) {
							if (sections[section].condition(this.steps, this.record, this.isShortLived)) {
								return section;
							}
						} else {
							return section;
						}
					});
					if (direction == 1) {
						this.steps[this.currentStep].activeSection = filteredSections[0];
					} else {
						this.steps[this.currentStep].activeSection = filteredSections[filteredSections.length - 1];
					}
					scroll('steps-progress-bar');
				}
			},
			changeStep(step) {
				this.errors.clear()
				if (step <= this.furthestStep) {
					this.currentStep = step;
					let sections = this.steps[this.currentStep].sections;
					let filteredSections = Object.keys(sections).filter((section) => {
						if (sections[section].hasOwnProperty('condition')) {
							if (sections[section].condition(this.steps, this.record, this.isShortLived)) {
								return section;
							}
						} else {
							return section;
						}
					});
					this.steps[this.currentStep].activeSection = filteredSections[0];
					scroll('steps-progress-bar');
				}
			},
			changeSection(sectionKey, forced = false) {
				console.log(sectionKey)
				console.log(sectionKey)
				let newSection = this.getNextSectionKey(sectionKey, 1);
				if (newSection == sectionKey) {
					this.updateSteps();
				} else {
					// this.steps[this.currentStep].sections[newSection].isVisible = true;
					this.steps[this.currentStep].activeSection = newSection;
					this.$nextTick(() => {
						scroll(newSection);
					});
				}
			},
			validateSection() {
				return this.$validator.validateAll();
			},
			sanitizeFields(section) {
				let data = {};
				data['id'] = this.record.id;
				Object.keys(section.fields).forEach((key) => {
					// console.log(key);
					if (key == 'occupants') {
						// console.log('occupants');
						if (!data.hasOwnProperty(key)) {
							data[key] = [];
						}
						// console.log(data);
						section.fields[key].model.forEach((row, index) => {
							let obj = {};
							Object.keys(row).forEach((key) => {
								if (key == 'id') {
									obj[key] = row[key];
								} else if (
									row[key].value === '' &&
									(section.fields[key].component === 'datepicker' ||
										section.fields[key].type === 'number')
								) {
									obj[key] = null;
								} else {
									obj[key] = row[key].value;
								}
							});
							data[key].push(obj);
						});
					} else if (key == 'partner') {
						section.fields[key].model.forEach((row, index) => {
							let obj = {};
							obj['is_adult'] = true;
							Object.keys(row).forEach((key) => {
								// console.log(key)
								if (key == 'id') {
									obj[key] = row[key];
								} else if (
									row[key].value === '' &&
									(section.fields[key].component === 'datepicker' ||
										section.fields[key].type === 'number')
								) {
									obj[key] = null;
								} else {
									obj[key] = row[key].value;
								}
							});
							// console.log(data);
							if (!data.hasOwnProperty('occupants')) {
								data['occupants'] = [];
								// console.log(data);
							}
							// console.log(data);
							data['occupants'].push(obj);
						});
					} else if (key == 'guarantors') {
						section.fields[key].model.forEach((row, index) => {
							let obj = {};
							Object.keys(row).forEach((key) => {
								// console.log('guarantor', key);
								if (['id', 'is_main'].includes(key)) {
									obj[key] = row[key];
								} else if (
									row[key].value === '' &&
									(section.fields[key].component === 'datepicker' ||
										section.fields[key].type === 'number')
								) {
									obj[key] = null;
								} else {
									obj[key] = row[key].value;
								}
							});
							if (!obj.hasOwnProperty('is_main') && index == 0) {
								obj['is_main'] = true;
							} else if (!obj.hasOwnProperty('is_main') || !obj['is_main']) {
								obj['is_main'] = false;
								obj['guarantor_type'] = 'physical';
							}
							if (!data.hasOwnProperty('guarantors')) {
								data['guarantors'] = [];
							}
							// console.log(obj);
							let main_guarantor = data['guarantors'].filter((el) => el.is_main);
							if (main_guarantor.length && obj['is_main']) {
								// console.log(main_guarantor[0]);
								data['guarantors'].forEach(
									(el, index) =>
										el.is_main && (data['guarantors'][index] = { ...main_guarantor[0], ...obj })
								);
							} else {
								data['guarantors'].push(obj);
							}
						});
					} else if (key == 'residences') {
						section.fields[key].model.forEach((row, index) => {
							if (!data.hasOwnProperty('residences')) {
								data['residences'] = [];
							}
							if (row['residence'].value !== '') {
								data['residences'].push(row['residence'].value);
							}
						});
					} else if (
						[
							'guarantor_incomes_n1',
							'guarantor_incomes_n2',
							'guarantor_incomes_other',
							'guarantor_incomes_other_amount',
							'guarantor_incomes_other_bis',
							'guarantor_incomes_other_amount_bis'
						].includes(key)
					) {
						// console.log(data);
						if (!data.hasOwnProperty('guarantors')) {
							data['guarantors'] = [];
						}
						if (!data['guarantors'].length) {
							// console.log();
							let obj = {};
							obj['is_main'] = true;
							if (
								section.fields[key].model.value === '' &&
								(section.fields[key].component === 'datepicker' ||
									section.fields[key].type === 'number')
							) {
								obj[key.replace('guarantor_', '')] = null;
							} else {
								obj[key.replace('guarantor_', '')] = section.fields[key].model.value;
							}
							data['guarantors'].push(obj);
						} else {
							data['guarantors'].forEach((el, index) => {
								// console.log(section.fields[key], 'null');
								if (
									el.is_main &&
									section.fields[key].model.value === '' &&
									(section.fields[key].component === 'datepicker' ||
										section.fields[key].type === 'number')
								) {
									data['guarantors'][index][key.replace('guarantor_', '')] = null;
								} else if (el.is_main) {
									data['guarantors'][index][key.replace('guarantor_', '')] =
										section.fields[key].model.value;
								}
							});
						}
						// console.log(data);
					} else if (
						!section.fields[key].hasOwnProperty('readOnly') &&
						(!section.fields[key].hasOwnProperty('condition') ||
							section.fields[key].condition(this.steps, this.record, this.isShortLived))
					) {
						// console.log('key', section.fields[key].model.value);
						if (Array.isArray(section.fields[key].model)) {
							data[key] = section.fields[key].model;
						} else if (
							section.fields[key].model.value === '' &&
							(section.fields[key].component === 'datepicker' || section.fields[key].type === 'number')
						) {
							data[key] = null;
						} else {
							data[key] = section.fields[key].model.value;
						}
					}
				});
				return data;
			},
			goPrevSection(sectionKey) {
				this.errors.clear()
				let newSection = this.getNextSectionKey(sectionKey, -1);
				if (newSection == sectionKey) {
					this.updateSteps(-1);
				} else {
					this.steps[this.currentStep].sections[newSection].isVisible = true;
					this.steps[this.currentStep].activeSection = newSection;
					this.$nextTick(function () {
						scroll(newSection);
					});
				}
			},
			goNextSection(sectionKey) {
				this.errors.clear()
				// console.log(sectionKey)
				if (sectionKey === 'documents_resident_civil_state' && !this.documents.some(document => document.document_type === 'civil_state')) {
					this.errors.add({
						msg: gettext('Vous devez ajouter votre état civil')
					})
				} else if (sectionKey === 'documents_resident_income' && !this.documents.some(document => document.document_type === 'income')) {
					this.errors.add({
						msg: gettext('Vous devez ajouter votre avis d\'imposition')
					})
				} else if (sectionKey === 'documents_resident_salary' && !this.documents.some(document => ['employer_attestation', 'salary', 'job_contract'].includes(document.document_type))) {
					this.errors.add({
						msg: gettext('Vous devez ajouter au moins l\'un des documents suivants pour continuer : bulletin de salaire, attestation de l\'employeur, contrat de travail')
					})
				} else if (sectionKey === 'documents_resident_student_card' && !this.documents.some(document => ['scolarity_certificate', 'student_card'].includes(document.document_type))) {
					this.errors.add({
						msg: gettext('Vous devez ajouter au moins l\'un des documents suivants pour continuer : copie de la carte d\'étudiant, copie du certificat de scolarité')
					})
				} else {
					this.validateSection().then((result) => {
						if (result && !this.isLoading) {
							this.isLoading = true;
							let currentSection = this.getSection(sectionKey),
								data = this.sanitizeFields(currentSection);
							if (currentSection.hasOwnProperty('endpoint')) {
								let endpoint = currentSection.endpoint;
								if (sectionKey == 'send_application') {
									let endpoint = currentSection.endpoint.replace('{resident_id}', this.record.id);
									this.get(endpoint)
										.then((response) => {
											this.scepiaCandidateId = response.data.scepia_candidate_id
											this.isComplete = true;
											this.isLoading = false;
											console.log('scroll to form')
											// wait to success animation complete
											setTimeout(() => {
												scroll('feedback-form')
											}, 3000)
										})
										.catch((error) => {
											this.isLoading = false;
											if (error.response.data.non_field_errors) {
												this.errors.add({
													msg: error.response.data.non_field_errors
												})
											}
										});
								} else {
									let formattedData = data
									if (sectionKey == 'commuting') {
										formattedData = {
											...data,
											future_commuting_time_hours: data.future_commuting_time_hours == '0' ? 0 : data.future_commuting_time_hours == "" ? null : data.future_commuting_time_hours,
											future_commuting_time_minutes: data.future_commuting_time_minutes == '0' ? 0 : data.future_commuting_time_minutes == "" ? null : data.future_commuting_time_minutes,
											commuting_time_hours: data.commuting_time_hours == '0' ? 0 : data.commuting_time_hours == '' ? null : data.commuting_time_hours,
											commuting_time_minutes: data.commuting_time_minutes == '0' ? 0 : data.commuting_time_minutes == '' ? null : data.commuting_time_minutes
										}
									}
									this.post(endpoint, formattedData)
										.then((response) => {
											if (sectionKey == 'appartment_characteristics') {
												this.get('residence-requests?resident=' + this.residentId)
													.then((responseResidences) => {
														this.isLoading = false;
														this.recordResidences = responseResidences.data.results.map(
															(el) => ({
																id: el.residence,
																is_colocation: el.residence_obj.is_colocation,
																is_short_lived: el.residence_obj.is_short_lived
															})
														);
														this.updateRecord(response.data);
														this.changeSection(sectionKey);
													})
													.catch((error) => {
														this.isLoading = false;
														// console.log(error);
													});
											} else {
												this.isLoading = false;
												this.updateRecord(response.data);
												this.changeSection(sectionKey);
											}
										})
										.catch((error) => {
											this.isLoading = false;
											if (error.response.data.non_field_errors) {
												this.errors.add({
													msg: error.response.data.non_field_errors
												})
											}
											// console.log(error);
										});
								}
							} else {
								// else if (currentSection.fields[Object.keys(currentSection.fields)[0]].model.length) {
								//   this.changeSection(sectionKey)
								// }
								this.changeSection(sectionKey);
								this.isLoading = false;
							}
						}
					});
				}
			},
			getNextSectionKey(key, i) {
				// let sections = this.steps[this.currentStep].sections;
				// let keys = Object.keys(sections).sort(function(a,b){return a-b;});
				let sections = this.steps[this.currentStep].sections;
				// console.log(this.currentStep);
				let filteredSections = Object.keys(sections).filter((section) => {
					if (sections[section].hasOwnProperty('condition')) {
						if (sections[section].condition(this.steps, this.record, this.isShortLived)) {
							return section;
						}
					} else {
						return section;
					}
				});
				// let keys = filteredSections.sort(function(a, b) {
				// 	return a - b;
				// });
				// console.log('key', key);
				// console.log('keys', filteredSections);
				let index = filteredSections.indexOf(key);
				// console.log(index);
				if ((i == -1 && index > 0) || (i == 1 && index < filteredSections.length - 1)) {
					index = index + i;
				} else if (i == -1 && index == -1) {
					index = filteredSections.length - 1;
				}
				// console.log(filteredSections[index]);
				return filteredSections[index];
			},
			uploadFile(referrer, files, sectionKey, fieldKey) {
				// console.log('event');
				// console.log(event);
				let formdata = new FormData();
				formdata.append('resident', this.residentId);
				formdata.append('document_type', fieldKey);
				if (referrer == 'guarantor') {
					formdata.append('guarantor', this.record.guarantors[0]);
				}
				Array.from(files).forEach((file) => {
					formdata.append('files', file);
				});
				this.post('documents', formdata)
					.then((response) => {
						response.data.results.forEach((file) => {
							this.documents.push(file)
							this.steps[this.currentStep].sections[sectionKey].fields[fieldKey].model.push(file);
							this.errors.clear()
						});
						// console.log(response);
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			deleteFile(referrer, id, sectionKey, fieldKey) {
				this.delete('documents/' + id)
					.then(() => {
						const documentIndex = this.documents.findIndex(document => document.id === id)
						if (documentIndex >= 0) {
							this.documents.splice(documentIndex, 1)
						}
						this.steps[this.currentStep].sections[sectionKey].fields[fieldKey].model = this.steps[
							this.currentStep
						].sections[sectionKey].fields[fieldKey].model.filter((file) => file.id != id);
						// console.log(response);
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			handleFeedback() {
				this.errors.clear()
				this.feedbackErrors = {}
				const data = {
					note: this.section.fields.note.model.value,
					difficulties_encounter: this.section.fields.difficulties_encounter.model.value,
					difficulties_detail: this.section.fields.difficulties_detail.model.value,
					improvements: this.section.fields.improvements.model.value,
					email: this.section.fields.email.model.value
				}
				this.post('candidate-feedback', data)
					.then((response) => {
						this.feedbackSent = true
					})
					.catch((errors) => {
						this.feedbackErrors = errors.response.data
						if (this.feedbackErrors.note) {
							this.feedbackErrors.note = this.feedbackErrors.note[0]
						}
						if (this.feedbackErrors.difficulties_encounter) {
							this.feedbackErrors.difficulties_encounter = this.feedbackErrors.difficulties_encounter[0]
						}
						if (this.feedbackErrors.difficulties_detail) {
							this.feedbackErrors.difficulties_detail = this.feedbackErrors.difficulties_detail[0]
						}
					})
			},
			onRadioChange(field) {
				if (field.name === 'difficulties_encounter') {
					if (field.model.value === true) {
						this.section.fields.difficulties_detail.label = gettext('Si oui, lesquelles ?')
						this.showField = true
					} else if (field.model.value === false) {
						this.errors.clear()
						this.section.fields.difficulties_detail.model.value = ''
						this.section.fields.difficulties_detail.label = ''
						this.showField = false
					}
				}
			}
		}
	});
}
